import React from "react";

import FormImageSelect from './FormImageSelect';
import FormCheck from './FormCheck';
import FormInput from './FormInput';
import FormFileUpload from './FormFileUpload';
import FormTextArea from "./FormTextArea";
import FormSubmit from "./FormSubmit";

import './BookletsForm.css'

const BookletsForm = ({ booklets, common, formFileUpload, handleChange, handleChangeOther, handleSubmit }) => {

  const { binding, size, cover, paper, pages, quantity, color, sides, bleed, proof, delivery } = booklets;
  const { completion, fullname, email, phone, message } = common;
  const { pdf } = formFileUpload;

  return (
    <form method="POST" action="https://formsubmit.co/4fceff67413373fe12dee9a8c3cb1caf" encType="multipart/form-data">
      <FormImageSelect product={binding} handleChange={handleChange} />
      <FormCheck label={size.label} options={size.options} handleChange={handleChange} handleChangeOther={handleChangeOther} />
      <FormImageSelect product={cover} handleChange={handleChange} />
      <FormCheck label={paper.label} options={paper.options} handleChange={handleChange} handleChangeOther={handleChangeOther} />
      <FormInput type={pages.type} label={pages.label} id={pages.id} classes={pages.classes} name={pages.name} handleChange={handleChange} />
      <FormInput type={quantity.type} label={quantity.label} id={quantity.id} classes={quantity.classes} name={quantity.name} handleChange={handleChange} />
      <FormCheck label={color.label} options={color.options} handleChange={handleChange} />
      <FormCheck label={sides.label} options={sides.options} handleChange={handleChange} />
      <FormCheck label={bleed.label} info={bleed.info} options={bleed.options} handleChange={handleChange} />
      <FormCheck label={proof.label} options={proof.options} handleChange={handleChange} />
      <FormCheck label={delivery.label} options={delivery.options} handleChange={handleChange} />
      <FormInput type={completion.type} label={completion.label} id={completion.id} classes={completion.classes} name={completion.name} handleChange={handleChange}  />
      <FormInput type={fullname.type} label={fullname.label} id={fullname.id} classes={fullname.classes} name={fullname.name} handleChange={handleChange} />
      <FormInput type={email.type} label={email.label} id={email.id} classes={email.classes} name={email.name} handleChange={handleChange} />
      <FormInput type={phone.type} label={phone.label} id={phone.id} classes={phone.classes} name={phone.name} handleChange={handleChange} />
      <FormFileUpload type={pdf.type} label={pdf.label} id={pdf.id} classes={pdf.classes} name={pdf.name} accept={pdf.accept} handleChange={handleChange} />
      <FormTextArea type={message.type} label={message.label} id={message.id} classes={message.classes} name={message.name} handleChange={handleChange} />
      <FormSubmit handleSubmit={handleSubmit} />
    </form>
  ) 
  
}

export default BookletsForm;